import React from 'react';
import { observer } from 'mobx-react-lite';
import { TextField } from '@material-ui/core';
import ReactInputMask from 'react-input-mask';

/** Estado mutável (ex.: MobX local) com logradouro, número, etc. */
export type EnderecoDetalhadoFornecedorState = {
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  cep: string;
  inscricao_estadual: string;
};


const FornecedorEnderecoDetalhadoFields = observer<{ state: EnderecoDetalhadoFornecedorState }>(({ state }) => (
  <>
    <TextField
      value={state.logradouro}
      onChange={(e) => {
        state.logradouro = e.target.value;
      }}
      label="Logradouro"
      fullWidth
    />
    <TextField
      value={state.numero}
      onChange={(e) => {
        state.numero = e.target.value;
      }}
      label="Número"
      fullWidth
    />
    <TextField
      value={state.complemento}
      onChange={(e) => {
        state.complemento = e.target.value;
      }}
      label="Complemento"
      fullWidth
    />
    <TextField
      value={state.bairro}
      onChange={(e) => {
        state.bairro = e.target.value;
      }}
      label="Bairro"
      fullWidth
    />
    <ReactInputMask value={state.cep} onChange={(e) => (state.cep = e.target.value)} mask="99999-999" maskChar="">
      {() => <TextField label="CEP" fullWidth />}
    </ReactInputMask>
    <TextField
      value={state.inscricao_estadual}
      onChange={(e) => {
        state.inscricao_estadual = e.target.value;
      }}
      label="Inscrição Estadual"
      fullWidth
    />
  </>
));

export default FornecedorEnderecoDetalhadoFields;
